import { geniFetch } from "../geniBackend";
import type { KaspiPublishStatus } from "./publicateKaspiGoodVersion";

export interface KaspiStatusResult {
  goodId: string;
  status: KaspiPublishStatus;
  error?: string;
}

/**
 * Просит backend обновить статусы Kaspi-публикаций. Backend дёргает Kaspi ТОЛЬКО для
 * товаров «в обработке» (processing) — опубликованные/ошибочные уже зафиксированы в БД
 * и повторно не запрашиваются. Возвращает список изменившихся/проверенных статусов.
 */
export const refreshKaspiStatuses = async (): Promise<KaspiStatusResult[]> => {
  try {
    return (await geniFetch<KaspiStatusResult[]>("/kaspi/goods/status", { method: "POST" })) ?? [];
  } catch {
    // Обновление статусов не должно ронять загрузку списка товаров.
    return [];
  }
};
